import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { DEFAULT_FILL_OPACITY, ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const IdentificationIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  isFilled,
  fillOpacity = DEFAULT_FILL_OPACITY,
}) => {
  const path = isFilled ? (
    <>
      <path
        d="M2 20V4a2 2 0 0 1 2-2h3.076a.77.77 0 1 1 0 1.538H4A.462.462 0 0 0 3.538 4v16a.462.462 0 0 0 .462.462h3.076l.08.005a.77.77 0 0 1 0 1.53l-.08.004H4a2 2 0 0 1-2-2zm18.462 0V4A.462.462 0 0 0 20 3.538h-3.077a.77.77 0 0 1 0-1.538H20a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2.001h-3.077a.77.77 0 0 1 0-1.539H20a.462.462 0 0 0 .462-.461z"
        fill={color}
      />
      <path
        d="M13.937 8.25a2.111 2.111 0 0 0-.61-1.286 2.127 2.127 0 0 0-1.292-.609l-.21-.01c-.563 0-1.103.222-1.502.619a2.112 2.112 0 0 0-.622 1.495v1.102h4.247V8.459l-.01-.208zm1.361 1.31h.343c.275 0 .54.096.75.268l.087.079.078.085c.173.21.268.474.268.748v6.08A1.178 1.178 0 0 1 15.642 18H8.01a1.177 1.177 0 0 1-1.178-1.063l-.007-.116V10.74c0-.313.125-.612.347-.833l.087-.08c.21-.171.476-.266.75-.266h.343V8.459c0-.917.366-1.797 1.018-2.446A3.481 3.481 0 0 1 11.825 5l.172.004a3.48 3.48 0 0 1 2.284 1.009 3.453 3.453 0 0 1 1.017 2.446v1.102z"
        fill={color}
      />
    </>
  ) : (
    <path
      d="M2 20V4a2 2 0 0 1 2-2h3.076a.77.77 0 1 1 0 1.538H4A.462.462 0 0 0 3.538 4v16a.462.462 0 0 0 .462.462h3.076l.08.005a.77.77 0 0 1 0 1.53l-.08.004H4a2 2 0 0 1-2-2zm18.462 0V4A.462.462 0 0 0 20 3.538h-3.077a.77.77 0 0 1 0-1.538H20a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2.001h-3.077a.77.77 0 0 1 0-1.539H20a.462.462 0 0 0 .462-.461zM7.514 17.77h8.718v-6.577H7.514v6.577zm6.895-9.611a2.369 2.369 0 0 0-.723-1.464 2.618 2.618 0 0 0-1.813-.72 2.62 2.62 0 0 0-1.814.72 2.357 2.357 0 0 0-.735 1.7v1.26h5.098v-1.26l-.013-.236zm1.551 1.495h.437c.31 0 .614.103.858.296l.102.088.093.098c.203.239.32.545.32.866v6.957c0 .368-.153.715-.413.965s-.606.385-.96.385h-9.05c-.354 0-.7-.136-.959-.385a1.34 1.34 0 0 1-.406-.828l-.007-.137v-6.957l.007-.136a1.34 1.34 0 0 1 .406-.828l.101-.088c.245-.193.549-.296.859-.296h.437v-1.26c0-1.06.438-2.07 1.208-2.81a4.158 4.158 0 0 1 2.88-1.147c1.074 0 2.11.41 2.878 1.148.77.74 1.21 1.75 1.21 2.81v1.26z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  )

  return (
    <SvgWrapper aria-label="Identification Icon" viewBox={viewBox} size={size} fill="none">
      {path}
    </SvgWrapper>
  )
}

export default IdentificationIcon
